import { mapActions, mapState } from 'vuex'
import * as types from '@/store/types'

export default {
  computed: {
    ...mapState({
      loadingGui: state => state.gui.loading
    })
  },
  methods: {
    ...mapActions({
      loadingSet: types.GUI.loading.set
    }),
    setLoadingGui () {
      this.loadingSet(true)
    },
    unsetLoadingGui () {
      this.loadingSet(false)
    }
  }
}
